import { Theme } from '@material-ui/core';

type ThemeProps = {
  theme: Theme;
};

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const styledFuncs = {
  // --------------- mixins using theme -----------------
  pad:
    (units = 1) =>
    ({ theme }: ThemeProps) =>
      theme.pad(units),
  pxToRem:
    (units: number) =>
    ({ theme }: ThemeProps) =>
      theme.typography.pxToRem(units),
  createTransition:
    (properties: string[], delay?: number, duration?: number) =>
    ({ theme }: ThemeProps) =>
      theme.transitions.create(properties, {
        duration: duration || theme.transitions.duration.standard,
        delay,
      }),
};

export default styledFuncs;
